import {
    CatalogProductsCriteriaBodyRestDto,
    ProductsBulkActionRequestRestDto
} from "@/api/pharma-cpc-product-mgmt/models";

export class ProductsBulkActionRequestRestDtoModel implements ProductsBulkActionRequestRestDto {
    clear_custom_name_fr?: boolean | null;
    clear_custom_name_nl?: boolean | null;
    clear_custom_sort_weight?: boolean | null;
    clear_custom_standard_price?: boolean | null;
    criteria: CatalogProductsCriteriaBodyRestDto;


    constructor(criteria: CatalogProductsCriteriaBodyRestDto) {
        this.criteria = criteria;
    }

    public static createWithDefaults(criteria: CatalogProductsCriteriaBodyRestDto): ProductsBulkActionRequestRestDtoModel {
        const result = new this(criteria);

        return result;
    }
}
